export const tenureChartOrderBy = ["total_tenure", "current_tenure"] as const;

export interface TenureChartPayload {
    company_id: number;
    start_date: string;
    end_date: string;
    person_ids: number[];
    sort_by?: typeof tenureChartOrderBy[number];
    sort_direction?: "ascending" | "descending";
    change?: true;
}

export interface TenureChartResponse {
    request: TenurechartRequest;
    tenure_chart: Tenurechart;
}

interface Tenurechart {
    company_name: string;
    people: TenureChartPerson[];
    overlap_index: Record<string, Targetcurrent>;
    xAxis: {
        min: string;
        max: string;
    };
    series: TenureChartSeries;
    errors: TenureChartErrors;
    transaction_list: TenureChartTransactionlist;
}

export interface TenureChartTransactionlist {
    transactions: TenureChartTransaction[];
    investors: TenureChartInvestorcompany[];
    sellers: TenureChartInvestorcompany[];
    types: TenureChartTransactionType[];
}

interface TenureChartTransactionType {
    transaction_type_id: number;
    name: string;
}

export interface TenureChartTransaction {
    transaction_id: number;
    date: string;
    capital_structure: string;
    company_is_investor: boolean;
    company_is_target: boolean;
    company_name: string;
    investor_companies: TenureChartInvestorcompany[];
}

interface TenureChartInvestorcompany {
    transaction_investor_id: number;
    transaction_id: number;
    company_id: number;
    company_name: string;
    investment_type: string;
}

interface TenureChartSeries {
    data: {
        color_id: string;
        is_current: boolean;
        start: string;
        end: string;
        person_id: number;
        company_id: number;
        interval: TenurechartInterval;
        person_work_history_id: number;
        errors: [];
    }[];
}

interface TenureChartErrors {
    timeline_discards: Record<string, ErrorData[]>;
}

interface ErrorData {
    color_id: string;
    is_current: boolean;
    start: string;
    end: string;
    person_id: number;
    company_id: number;
    interval: TenurechartInterval;
}

export interface TenureChartXAxis {
    min: string;
    max: string;
}

interface TenurechartInterval {
    years: number;
    months: number;
    days: number;
}

interface Targetcurrent {
    company_id: number;
    company_name?: string;
    name?: string;
    person_ids: number[];
}

export interface TenureChartPerson {
    person_id: number;
    current_role: TenureChartPersonCurrentrole;
    name: string;
}

interface TenureChartPersonCurrentrole {
    jobtitle: string;
    company_name: string;
    level: string;
    function: string;
}

interface TenurechartRequest {
    company_id: number;
    person_ids: number[];
    start: string;
    end: string;
}
